// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.renter.v1.conversation.SatelliteWebRenterConversationHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  SatelliteWebRenterConversationHandler_addMessage,
  SatelliteWebRenterConversationHandler_getLatestConversations,
  SatelliteWebRenterConversationHandler_getLatestConversations_Path,
  SatelliteWebRenterConversationHandler_getMessages,
  SatelliteWebRenterConversationHandler_getMessages_Path,
  SatelliteWebRenterConversationHandler_getMessagesByInquiryId,
  SatelliteWebRenterConversationHandler_getMessagesByInquiryId_Path,
  SatelliteWebRenterConversationHandler_updateStatus,
} from '@zg-rentals/ts-satellite-client';

import type {
  SatelliteWebRenterConversationAddMessageRequestDto,
  SatelliteWebRenterConversationAddMessageResponseDto,
  SatelliteWebRenterConversationGetLatestConversationsRequestDto,
  SatelliteWebRenterConversationGetLatestConversationsResponseDto,
  SatelliteWebRenterConversationGetMessagesByInquiryIdRequestDto,
  SatelliteWebRenterConversationGetMessagesByInquiryIdResponseDto,
  SatelliteWebRenterConversationGetMessagesRequestDto,
  SatelliteWebRenterConversationGetMessagesResponseDto,
  SatelliteWebRenterConversationUpdateStatusRequestDto,
} from '@zg-rentals/ts-satellite-client';

export interface SatelliteWebRenterConversationHandler_addMessage_Args {
  postData: SatelliteWebRenterConversationAddMessageRequestDto;
}

export type SatelliteWebRenterConversationHandler_addMessage_Options = UseMutationOptions<
  SatelliteWebRenterConversationAddMessageResponseDto,
  unknown,
  SatelliteWebRenterConversationHandler_addMessage_Args
>;

/**
 * Add a message to a conversation
 */
export const useSatelliteWebRenterConversationHandler_addMessage = ({
  httpClient,
  ...options
}: Omit<SatelliteWebRenterConversationHandler_addMessage_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebRenterConversationHandler_addMessage_Args) =>
      SatelliteWebRenterConversationHandler_addMessage(args.postData, httpClient),
  });
};

export type SatelliteWebRenterConversationHandler_getLatestConversations_Options = UseQueryOptions<
  SatelliteWebRenterConversationGetLatestConversationsResponseDto,
  unknown,
  SatelliteWebRenterConversationGetLatestConversationsResponseDto,
  readonly [string, SatelliteWebRenterConversationGetLatestConversationsRequestDto]
>;

const SatelliteWebRenterConversationHandler_getLatestConversations_GetKey = (
  postData: SatelliteWebRenterConversationGetLatestConversationsRequestDto,
) => [SatelliteWebRenterConversationHandler_getLatestConversations_Path, postData] as const;

export const SatelliteWebRenterConversationHandler_getLatestConversations_queryOptions = (
  postData: SatelliteWebRenterConversationGetLatestConversationsRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebRenterConversationHandler_getLatestConversations_GetKey(postData),
    queryFn: () => SatelliteWebRenterConversationHandler_getLatestConversations(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get a renter's most recently updated conversations. Each conversation will include one message for that conversation. If the entire conversation consists of nothing but system messages, then the message included will be the most recent system message, otherwise the message included will be the most recent user message even if the most recent message is actually a system message. That is, system messages will only be returned if the entire conversation is composed solely of system messages.
 */
export const useSatelliteWebRenterConversationHandler_getLatestConversations = (
  postData: SatelliteWebRenterConversationGetLatestConversationsRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebRenterConversationHandler_getLatestConversations_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebRenterConversationHandler_getLatestConversations_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebRenterConversationHandler_getLatestConversations.getKey =
  SatelliteWebRenterConversationHandler_getLatestConversations_GetKey;

export type SatelliteWebRenterConversationHandler_getMessages_Options = UseQueryOptions<
  SatelliteWebRenterConversationGetMessagesResponseDto,
  unknown,
  SatelliteWebRenterConversationGetMessagesResponseDto,
  readonly [string, SatelliteWebRenterConversationGetMessagesRequestDto]
>;

const SatelliteWebRenterConversationHandler_getMessages_GetKey = (
  postData: SatelliteWebRenterConversationGetMessagesRequestDto,
) => [SatelliteWebRenterConversationHandler_getMessages_Path, postData] as const;

export const SatelliteWebRenterConversationHandler_getMessages_queryOptions = (
  postData: SatelliteWebRenterConversationGetMessagesRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebRenterConversationHandler_getMessages_GetKey(postData),
    queryFn: () => SatelliteWebRenterConversationHandler_getMessages(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get messages for a conversation
 */
export const useSatelliteWebRenterConversationHandler_getMessages = (
  postData: SatelliteWebRenterConversationGetMessagesRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebRenterConversationHandler_getMessages_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebRenterConversationHandler_getMessages_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebRenterConversationHandler_getMessages.getKey = SatelliteWebRenterConversationHandler_getMessages_GetKey;

export type SatelliteWebRenterConversationHandler_getMessagesByInquiryId_Options = UseQueryOptions<
  SatelliteWebRenterConversationGetMessagesByInquiryIdResponseDto,
  unknown,
  SatelliteWebRenterConversationGetMessagesByInquiryIdResponseDto,
  readonly [string, SatelliteWebRenterConversationGetMessagesByInquiryIdRequestDto]
>;

const SatelliteWebRenterConversationHandler_getMessagesByInquiryId_GetKey = (
  postData: SatelliteWebRenterConversationGetMessagesByInquiryIdRequestDto,
) => [SatelliteWebRenterConversationHandler_getMessagesByInquiryId_Path, postData] as const;

export const SatelliteWebRenterConversationHandler_getMessagesByInquiryId_queryOptions = (
  postData: SatelliteWebRenterConversationGetMessagesByInquiryIdRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: SatelliteWebRenterConversationHandler_getMessagesByInquiryId_GetKey(postData),
    queryFn: () => SatelliteWebRenterConversationHandler_getMessagesByInquiryId(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get the most recent 10 messages for a conversation by inquiry Id
 */
export const useSatelliteWebRenterConversationHandler_getMessagesByInquiryId = (
  postData: SatelliteWebRenterConversationGetMessagesByInquiryIdRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebRenterConversationHandler_getMessagesByInquiryId_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...SatelliteWebRenterConversationHandler_getMessagesByInquiryId_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useSatelliteWebRenterConversationHandler_getMessagesByInquiryId.getKey =
  SatelliteWebRenterConversationHandler_getMessagesByInquiryId_GetKey;

export interface SatelliteWebRenterConversationHandler_updateStatus_Args {
  postData: SatelliteWebRenterConversationUpdateStatusRequestDto;
}

export type SatelliteWebRenterConversationHandler_updateStatus_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebRenterConversationHandler_updateStatus_Args
>;

/**
 * Update conversation status
 */
export const useSatelliteWebRenterConversationHandler_updateStatus = ({
  httpClient,
  ...options
}: Omit<SatelliteWebRenterConversationHandler_updateStatus_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebRenterConversationHandler_updateStatus_Args) =>
      SatelliteWebRenterConversationHandler_updateStatus(args.postData, httpClient),
  });
};
